import {
  ClipboardIcon,
  PhoneIcon,
  ArrowDownTrayIcon
} from "@heroicons/react/20/solid";
import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";

function LinkGen(c) {
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [copy, setCopy] = useState("Copy to Clipboard");
  const channel = c["channel"];

  useEffect(() => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: "smooth",
    });
  }, [show]);

  var link = "";
  var cName = "";
  var title = "";
  var showMessage = 0;
  var mSubTitle = "";
  var nSubTitle = "";

  switch (channel) {
    case "wa":
      link = "https://wa.me/" + phone + "?text=" + message;
      cName = "WhatsApp";
      title = "Your WhatsApp Number";
      nSubTitle =
        "Include country code without + symbol. Eg. if country code is +65 and WhatsApp number is 84068880, then type 6584068880 below.";
      mSubTitle =
        "Automatically include this text when a user clicks on your chat link, making it easier to start a conversation.";
      showMessage = 1;
      break;
    case "tg":
      link = "https://t.me/" + phone;
      title = "Your Telegram Username";
      nSubTitle =
        "You should have received this name while creating your bot. Bot usernames always end in 'bot' (e.g. AliceSGbot)";
      cName = "Telegram";
      showMessage = 0;
      break;
    case "viber":
      link = "viber://pa?chatURI=" + phone + "?text=" + message;
      cName = "Viber";
      title = "Your Viber URI";
      nSubTitle = "It can be found in the your bot's Admin Panel";
      showMessage = 1;
      mSubTitle =
        "The value of this parameter will appear in the text input field when the 1-on-1 chat with the bot is opened by pressing the deep link. The user will be able to send the text as it is, edit it, or delete it.";
      break;
    case "line":
      cName = "Line";
      title = "Your Line ID";
      link = "https://line.me/R/ti/p/" + phone;
      nSubTitle =
        'You can find the LINE ID of your LINE Official Account, which starts with the "@" symbol, in the header of LINE Official Account Manager';
      showMessage = 0;
      break;
    default:
      break;
  }

  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "chat-by-myalice.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const onCopy = () => {
    navigator.clipboard.writeText(link);
    setCopy("Copied");
  };

  const cleanData = (x) => {
    switch (channel) {
      case 'wa':
        return x.replace(/[^0-9]/g, "");
      case 'tg':
        return x.replace("@", "");
      case 'line':
        return x.replace("@", "");
      case 'viber':
        return x;
      default:
        return x;
    }
  }

  return (
    <div className="min-h-full flex justify-center sm:px-6 lg:px-8">
      <div className="mt-8 sm:max-w-xl">
        <div className="bg-white py-8 px-4 sm:px-10">
          <div className="space-y-6">
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700"
              >
                {title}
              </label>

              <div className="mt-1">
                <input
                  name="phone"
                  autoFocus
                  type="text"
                  value={phone}
                  onChange={(e) =>
                    setPhone(cleanData(e.target.value))
                  }
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                />
              </div>
              <p className="mt-2 text-sm text-gray-500" id="email-description">
                {nSubTitle}
              </p>
            </div>
            {showMessage ? (
              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-gray-700"
                >
                  Welcome Message (Optional)
                </label>

                <div className="mt-1">
                  <input
                    name="message"
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  />
                </div>
                <p
                  className="mt-2 text-sm text-gray-500"
                  id="email-description"
                >
                  {mSubTitle}
                </p>
              </div>
            ) : (
              <></>
            )}
          </div>
          <button
            onClick={() => {
              setShow(true);
            }}
            className="w-full flex justify-center mt-6 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            Generate {cName} Chat Link
          </button>

          {show && (
            <div className="mt-6">
              <div className="bg-primary-light sm:rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Your {cName} Click-To-Chat Link
                  </h3>
                  <div className="mt-2 max-w-xl text-sm text-gray-500">
                    <p>{link}</p>
                  </div>
                  <div className="mt-5 flex gap-x-2">
                    <button
                      onClick={onCopy}
                      type="button"
                      className="inline-flex items-center px-3 py-2 text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      <ClipboardIcon
                        className="-ml-1 mr-2 h-5 w-5"
                        aria-hidden="true"
                      />
                      {copy}
                    </button>
                    <a
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                      type="button"
                      className="inline-flex items-center px-3 py-2 text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      <PhoneIcon
                        className="-ml-1 mr-2 h-5 w-5"
                        aria-hidden="true"
                      />
                      Open on {cName}
                    </a>
                  </div>
                </div>
                <div className="px-4 py-5 sm:p-6">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Your {cName} QR Code
                  </h3>
                  <div className="mt-4 mb-2">
                    <QRCode id="qr-gen" size={128} value={link} />
                  </div>

                  <div className="mt-5 flex gap-x-2">
                    <button
                      onClick={downloadQRCode}
                      type="button"
                      className="inline-flex items-center px-3 py-2 text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      <ArrowDownTrayIcon
                        className="-ml-1 mr-2 h-5 w-5"
                        aria-hidden="true"
                      />
                      Download QR Code
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LinkGen;
